import { combineReducers } from 'redux';
import home from '../../modules/home/reducer';

const rootReducer = combineReducers({
    home
})

export default rootReducer;